export enum VOTES {
    /**
     * @value Downvote
     */
    DOWNVOTE = 'POST_DOWNVOTE',
    /**
     * @value {"one":"%NUMBER% Downvote","other":"%NUMBER% Downvotes"}
     * @description Vote results
     */
    PLURALIZED_DOWNVOTES = 'POST_PLURALIZED_DOWNVOTES',
    /**
     * @value {"one":"%NUMBER% Upvote","other":"%NUMBER% Upvotes"}
     * @description Vote result
     */
    PLURALIZED_UPVOTES = 'POST_PLURALIZED_UPVOTES',
    /**
     * @value Upvote
     */
    UPVOTE = 'POST_UPVOTE',
}
